(function($) {

	var isInit = 0,
		domReady = 0,
		endpoint = "/rtbs.php",
		dataFileDate = null,
		ticketData = null,
		cartData,
		cart,
		chosenDate = null,
		chosenDatePretty = null;
    // promo = window.ticketing.promo;
  
  //In javascript months start from 0
  var disabled_dates = [  
    [(new Date()).getFullYear(), 11, 25], //xmas day
    { from: [2022, 1,  8], to: [2022, 1, 10] },
    { from: [2022, 1, 15], to: [2022, 1, 17] },
    { from: [2022, 1, 22], to: [2022, 1, 24] },
    { from: [2022, 1, 28], to: [2022, 2,  4] },
    { from: [2022, 2,  7], to: [2022, 2, 11] },
    { from: [2022, 2, 14], to: [2022, 2, 18] },
    { from: [2022, 2, 21], to: [2022, 2, 25] },
    { from: [2022, 2, 28], to: [2022, 3,  1] },
    { from: [2022, 3,  4], to: [2022, 3,  8] },
    { from: [2022, 3, 11], to: [2022, 3, 14] },
    { from: [2022, 4,  3], to: [2022, 4,  5] },
    { from: [2022, 4, 10], to: [2022, 4, 12] },
    { from: [2022, 4, 17], to: [2022, 4, 19] },
    { from: [2022, 4, 24], to: [2022, 4, 26] },
    { from: [2022, 4, 31], to: [2022, 5,  2] },
    { from: [2022, 5,  7], to: [2022, 5,  9] },
    { from: [2022, 5, 14], to: [2022, 5, 16] },
    { from: [2022, 5, 21], to: [2022, 5, 23] },
    { from: [2022, 5, 28], to: [2022, 5, 30] },
    { from: [2022, 6,  5], to: [2022, 6,  7] },
    { from: [2022, 6, 26], to: [2022, 6, 28] },
    { from: [2022, 7,  2], to: [2022, 7,  4] },
    { from: [2022, 7,  9], to: [2022, 7, 11] },
    { from: [2022, 7, 16], to: [2022, 7, 18] },
    { from: [2022, 7, 23], to: [2022, 7, 25] },
    { from: [2022, 7, 30], to: [2022, 8,  1] },
    { from: [2022, 8,  6], to: [2022, 8,  8] },
    { from: [2022, 8, 13], to: [2022, 8, 15] },
    { from: [2022, 8, 20], to: [2022, 8, 22] },
    { from: [2022, 8, 27], to: [2022, 8, 29] },
    { from: [2022, 9, 18], to: [2022, 9, 20] },
    { from: [2022, 9, 25], to: [2022, 9, 27] },
    { from: [2022,10,  1], to: [2022,10,  3] },
    { from: [2022,10,  8], to: [2022,10, 10] },
    { from: [2022,10, 15], to: [2022,10, 17] },
  ]

	$.getJSON(endpoint+'?data=true', function(obj) {
		dataFileDate = obj.date;
		ticketData = obj.data;
		if(!isInit && domReady) initCart();
	});

	//doc ready
	$(function() {
		domReady = 1;
		initTicketChooser();
		initDetailsForm();
		initConfirmForm();
		if(!isInit && ticketData) initCart();
	});

	function checkDataForDate(dateInput, oldDate, oldDatePretty) {

		var picker = dateInput.pickadate('picker');
		var hiddenInput = dateInput.siblings('input[type=hidden]');
		var submitValue = hiddenInput.val();
		var q = submitValue ? '&date='+submitValue : '';

		$.getJSON(endpoint+'?data=true'+q, function(obj) {

			if(obj.date != dataFileDate) {

				var change = confirm("The page needs to be refreshed to update ticket prices for this date. \nClick OK to refresh, or CANCEL to stay on this page and keep the previous date.");
				if(change)
				{
					$('.btn-next')
						.before('<input type="hidden" name="oldDataDate" value="'+chosenDate+'">')
						.attr('name', 'dataUpdate')
						.click();

						picker.close();
				}
				else
				{
					picker.set('select', chosenDatePretty).close();
				}
			}
			else {
				chosenDate = hiddenInput.val();
				chosenDatePretty = picker.get();
			}

		});
	}

	function initCart() {

		cartData = new Cart(ticketData);

		cart = $('.widget-cart');
		var items = cart.find('.cart-item');

		items.each(function(){
			var item = $(this);
			var id = item.data('id');
			var amount = item.data('amount');
			cartData.updateItem(id, amount);
		});

    isInit = 1;
    
    var proceed = $('.widget-tickets button.proceed-enter-details');
    cart.find('.btn-proceed').on('click', function(e){
      proceed.click();
    })
	}

	function initTicketChooser() {

		var widget = $('.widget-tickets');
		if(!widget.length) return;

		var userHasntOpenedDatePicker = true,
				userHasntSeenFlashMessage = true,
				form = widget.find('form'),
				ticketInput = widget.find('.number'),
				ticketInputWrapper = ticketInput.parents('.element'),
				btn = $('<span class="btn"></span>'),
				add = btn.clone(),
				sub = btn.clone(),
				tooltipTimeout = null;

		//form.find('label')
			form.find('.item-info')
				.tooltip({
					trigger:'focus',
					placement:'right'
				})
				.on('click', function(e){
					e.preventDefault();
				})
				.on('blur', function(e){
					$(this).tooltip('hide');
					clearTimeout(tooltipTimeout);
				})
				.on('shown.bs.tooltip', function(){
					var self = this;
					tooltipTimeout = setTimeout(function(){
						$(self).blur();
					}, 6000)
				})

		var yearFromNow = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
		var datepicker = form.find('.datepicker');
		chosenDate = datepicker.val();

		datepicker.pickadate({
			//container: 'body',
			//editable: true,
			format: 'ddd, d mmm yyyy',
			formatSubmit: 'yyyy-mm-dd',
			selectYears: false,
			hiddenName: true,
			closeOnSelect: true,
			min: ((new Date()).getHours() < 15) ? true : 1,
			//min: true,
			// max: promo == 'aa-gift' ? yearFromNow : false,
			max: yearFromNow,
			today: '',
      clear: '',
      firstDay: 1,
      disable: disabled_dates,
			onStart: function() {
        this.set('select', this.get('highlight').obj)
		  },
			onOpen: function() {
        userHasntOpenedDatePicker = false;
			},
			// onClose: function() {
		  //   //datepicker.focus();
		  // },
		})
		.bind('change', function() {
			checkDataForDate(datepicker)
    })
    // .bind('focus', function() {
    //   $(this).blur();
    // });

		chosenDatePretty = datepicker.pickadate('picker').get()

		add.html('plus').addClass('btn-add');
		sub.html('minus').addClass('btn-sub');

		ticketInputWrapper.prepend(sub);
		ticketInputWrapper.append(add);

		//ticketInput.prop('type','text').addClass('mod');
		ticketInput.addClass('mod').each(function(){
			var input = $(this);
			setMinMax(input);
		})

		form.bind('submit', function(e){

			var valid = false;
			var dateInput = datepicker.siblings('input[type=hidden]');
			var inputs = form.find('.number');

			var dateGiven = dateInput.val();
			var date = new Date(dateGiven);

			if(isNaN(date.getTime())) {
				e.preventDefault();
				flashMessage('The date entered was invalid!<br> Please use the format YYYY-MM-DD');
			}
			else {
				date.setHours(0,0,0,0);
				var dateF = formatDate(date);
				dateInput.val(dateF);
			}

			var isValid = validateCart();
			if(isValid) {
				e.preventDefault()
				return false;
			}

			//console.log(dateGiven, dateInput[0].value, dateF);
			//var tomorrow = new Date();
			//tomorrow.setHours(0,0,0,0);
			//tomorrow.setDate(tomorrow.getDate() + 1);
			//var tomorrowF = formatDate(tomorrow);

			//else if(date.getTime() < tomorrow.getTime()) {
			//	e.preventDefault();
			//	flashMessage('Online sales for your chosen date are now closed!');
			//}

			inputs.each(function() {
				if(this.value > 0) {
					valid = true;
					return false;
				}
			});

			if(form.hasClass('novalidate')) {
				//do nothing
			}
			else if(!valid && $('input[name=oldDataDate]').length == 0) {
				e.preventDefault();
				flashMessage("You haven't selected any tickets!");
			}
			else if(userHasntOpenedDatePicker && userHasntSeenFlashMessage)
			{
				e.preventDefault();
				flashMessage(
					"You haven’t chosen a date, please let us know when you would like to visit.",
					8000
				);

				userHasntSeenFlashMessage = false;
			}

		});

		widget
			.delegate('.btn-add', 'mousedown', function(e){ e.preventDefault(); })
			.delegate('.btn-sub', 'mousedown', function(e){ e.preventDefault(); })
		.delegate('.btn-add', 'click', function(e) {

			var input = $(this).siblings('input');
			var val = parseInt(input.val()) + 1;
			var max = input.attr('max');

			if(max && val > max) return;
			input.val(val).trigger('change');

		})
		.delegate('.btn-sub', 'click', function(e) {

			var input = $(this).siblings('input');
			var val = parseInt(input.val()) - 1;
			var min = input.attr('min');

			if(min && val < min) return;
			input.val(val).trigger('change');

		})
		.delegate('.number', 'keydown', function(e) {

			if(e.which != 38 && e.which != 40) return;

			var input = $(this);
			var val = parseInt(input.val());

			if(e.which == 38) {
				val = val + 1;
				var max = input.attr('max');
				if(max && val > max) val = max;
			}
			else if(e.which == 40) {
				val = val - 1;
				var min = input.attr('min');
				if(min && val < min) val = min;
			}

			input.val(val).trigger('change');

		})
		.delegate('.number', 'change', function(e) {

			var input = $(this);

			if( ! $.isNumeric( input.val() )) {
				input.val(0);
			}

			setMinMax(input);

			updateCart(input.data(), input.val());

		});

		//AA discount
		var aaVerifyBtn = $('.aa-verify');

		if(aaVerifyBtn.length)
		{
			var aaPopup = $('.aa-popup'),
					aaCardInput = $('#aa-card'),
					aaFreeInput = $('#aa-free'),
					aaSubmit = $('#aa-submit'),
					aaCancel = $('#aa-cancel');

			//open popup
			aaVerifyBtn.on('click', function(e){
				e.preventDefault();
				aaPopup.addClass('open');
				window.parent.resizeIframe(document.body.offsetHeight);
				setTimeout(function(){
					aaCardInput.focus();
				}, 100)
			});

			//close popup
			aaCancel.on('click', function(e){
				aaPopup.removeClass('open');
			});

			//mask card format
			aaCardInput
				.mask("0000 0000 0000 0000")
				.on('keydown', function(e){
					if(e.which == 13) {
						e.preventDefault();
						aaSubmit.trigger('click');
					}
				});

			aaSubmit.on('click', function() {

				var date = datepicker.siblings('input[type=hidden]').val(),
						card = aaCardInput.val().split(' ').join(''),
						free = aaFreeInput.length ? aaFreeInput.val().trim() : '';

				if(card.length > 0 && card.length < 16) {
					showAAError(aaCardInput, "Your card number should be 16 digits long.");
					return false;
				}

				verifyAA(card, aaCardInput, function() {

					var date = datepicker.val();
					verifyAAFree(free, aaFreeInput, date, aaVerified)

				});

			})

			var showStandard = $('button[name="showStandard"]');
			if(showStandard.length)
			{
				showStandard.on('click', function() {
					form.addClass('novalidate')
				})
			}

			//if promo showing and AA card not validated show AA pop on load
			// if(promo == 'aa-gift' && !aaCardInput.hasClass('valid'))
			// {
			// 	aaPopup.addClass('open');
			// 	setTimeout(function(){
			// 		aaCardInput.focus();
			// 	}, 100)
			// }
		}
	}

	function validateCart(onlyRemove) {

		$('.widget-tickets form > .error').remove();
		var cartErrors = cartData.validate();

		if(cartErrors.length)
		{
			if(!onlyRemove)
			{
				for(var error in cartErrors)
				{
					var error = cartErrors[error];
					var el = $('.label[for="item-'+error.id+'"]').next();
					if(el.length) {
						el.after('<p class="error">'+error.message+'</p>');
					}
				}

				var firstError = $('.widget-tickets .error:first');
        firstError.prev().find('input,textarea').focus();
        
				//flashMessage("The are errors in the form, please resolve them and submit again.");
			}

			return true;
		}
		else {
			return false;
		}
	}

	function setMinMax(input) {

		var min = input.attr('min');
		var max = input.attr('max');
		var sub = input.siblings('.btn-sub');
		var add = input.siblings('.btn-add');

		if(input.val() < min)
			input.val(min);

		if(input.val() > max)
			input.val(max);

		if(input.val() == min)
			sub.addClass('disabled');
		else
			sub.removeClass('disabled');

		if(input.val() == max)
			add.addClass('disabled');
		else
			add.removeClass('disabled');
	}

	function showAAError(input, message) {

		var parent = input.parent();
		var error = parent.find('.message');

		if(!error.length) {
			error = $('<p class="message"></p>');
		}

		parent.addClass('error');
		error.html(message).insertAfter(input);
		input.focus();
	}

	function verifyAA(cardNumber, cardInput, callback) {

		var aaSubmit = $('#aa-submit').attr('disabled',true);

		$.ajax({
			dataType: "json",
			url: endpoint+'?aa-verify=true',
			data: { card: cardNumber }
		})
		.done(function( json ) {

			aaSubmit.removeAttr('disabled');

			if(json.data)
			{
				if(json.data.success)
				{
					//console.log('verifyAA',json);
					callback();
				}
				else
				{
          console.log(json.data);
          if(json.data.message.indexOf('SSL certificate') !== -1) {
            json.data.message = "Sorry we can't connect to the AA servers at this time"
          }
					showAAError(cardInput, json.data.message);
				}
			}
		})
		.fail(function( jqxhr, textStatus, error ) {
			aaSubmit.removeAttr('disabled');
			var err = textStatus + ", " + error;
			//console.log( "AA Fail: " + err );
		});

	}

	function verifyAAFree(promocode, input, date, callback) {

		var aaSubmit = $('#aa-submit').attr('disabled',true);

		$.ajax({
			dataType: "json",
			url: endpoint+'?aa-verify-free=true',
			data: { promocode: promocode, promodate: date }
		})
		.done(function( json ) {

			aaSubmit.removeAttr('disabled');

			if(json.data)
			{
				if(json.data.success)
				{
					//console.log('verifyAAFree',json);
					//change to free ticket here
					callback();
				}
				else
				{
					//console.log(json.data);
					showAAError(input, json.data.message);
				}
			}
		})
		.fail(function( jqxhr, textStatus, error ) {
			aaSubmit.removeAttr('disabled');
			var err = textStatus + ", " + error;
			//console.log( "AA Free: " + err, jqxhr );
		});

	}

	function aaVerified() {

		var card = $('#aa-card');
		var free = $('#aa-free');
		var aaComp = $('.aaComp').addClass('hidden');
		var aaCompInput = $('.aa-element.aaComp input').val(0);
		var fields = $('.aa-element');

		if(free.length) free.removeClass('valid');

		$('.aa-popup').removeClass('open');

		if(card.val().length == 0)
		{
			//var val = 0;
			fields.addClass('disabled')
						.find('input').addAttr('disabled');
		}
		else
		{
			//var val = 1;
			fields.removeClass('disabled')
				.find('input').removeAttr('disabled').trigger('change')
				.first().focus();

			var label = fields.prev();
			setTimeout(function(){ label.addClass('flash') }, 200)
			setTimeout(function(){ label.removeClass('flash') }, 800)

			if(free.length && free.val().length != 0) {
				free.addClass('valid')
				aaComp.removeClass('hidden');
				aaCompInput.val(1).trigger('change');
			}
		}

		//var input = fields.find('input');
		//input.val(val).trigger('change');
		//setMinMax(input);

		var cardError = card.parent().find('.message');
		if(cardError) cardError.remove();

		var promoError = free.parent().find('.message');
		if(promoError) promoError.remove();
	}

	function initDetailsForm() {

		var widget = $('.widget-contact-details');
		if(!widget.length) return;

		var form = widget.find('form').attr('novalidate', "");
		var next = form.find('.btn-next');
		var inputs = form.find('.input');

		next.bind('click', function(e) {

			var valid = true;
			inputs.each(function() {

				if(this.id == 'contact-fname') {
					if(!validName(this.value)) {
						addError(this, "Please enter your first name");
						valid = false;
					} else removeError(this);
				}
				else if(this.id == 'contact-lname') {
					if(!validName(this.value)) {
						addError(this, "Please enter your last name");
						valid = false;
					} else removeError(this);
				}
				else if(this.id == 'contact-email') {
					if(!validEmail(this.value)) {
						addError(this, "Please enter a valid email");
						valid = false;
					} else removeError(this);
				}
				else if(this.id == 'contact-phone') {
					if(!validPhone(this.value)) {
						addError(this, "Please enter a valid phone number");
						valid = false;
					} else removeError(this);
				}
				else if(this.id == 'contact-address1') {
					if(!validName(this.value)) {
						addError(this, "Please enter your street address");
						valid = false;
					} else removeError(this);
				}
				else if(this.id == 'contact-address2') {
					if(!validName(this.value)) {
						addError(this, "Please enter your suburb / town");
						valid = false;
					} else removeError(this);
				}
				else if(this.id == 'contact-address3') {
					if(!validName(this.value)) {
						addError(this, "Please enter your city / region");
						valid = false;
					} else removeError(this);
        }
        else if(this.id == 'contact-guest-names') {
					if(!validName(this.value)) {
						addError(this, "Please enter the names of your guests");
						valid = false;
					} else removeError(this);
				}
			});

			if(!valid) {
        e.preventDefault();
        window.parent.resizeIframe(document.body.offsetHeight);
				//flashMessage("You haven't selected any tickets!");
			}
		});
  }
  
	function initConfirmForm() {

		var widget = $('.widget-confirm-order');
		if(!widget.length) return;

		var form = widget.find('form').attr('novalidate', "");
		var next = form.find('.btn-next');
		var inputs = form.find('.input');

		next.bind('click', function(e) {

			var valid = true;
			inputs.each(function() {
        
				if(this.id == 'terms') {
					if(!this.checked) {
						addError(this, "Please agree to the Terms & Conditions before proceeding");
						valid = false;
					} else removeError(this);
				}

			});

			if(!valid) {
				e.preventDefault();
		  }
		});
	}

	function updateCart(data, amount) {

		var id = data.id;
		var ticket = ticketData[id];
		var name = ticket.label;
		var xamount = 'x'+amount;
		var items = cart.find('.cart-item');
		var item = cart.find('#item-'+id+'-total');
		var empty = cart.find(".cart-empty");

		cartData.updateItem(id, amount);

		if(item.length) {

			if(amount > 0) {
				//console.log(amount);
				item.html(cartData.getItemTotal(id));
				item.siblings('.item-amount').html(xamount);
			}
			else {
				var par = item.parent().remove();
				if(items.length == 1) empty.show();
			}
		}
		else if(amount > 0) {
			empty.hide();
			var price = cartData.getItemTotal(id);
			var lastItem = cart.find('.cart-item').last();
			var row = $('<tr class="cart-item"><th>'+name+'</th><td class="item-amount">'+xamount+'</td><td class="item-total" id="item-'+id+'-total">'+price+'</td></tr>');
			if(lastItem.length)
					 row.insertAfter(lastItem);
			else row.insertAfter(empty);
		}

		$('#family-discount').html('-'+cartData.getFamilyDiscount());
		//$('#online-discount').html('-'+cartData.getWebDiscount());
		$('#aa-discount').html('-'+cartData.getAADiscount());
		$('#cart-total').html(cartData.getTotal());

		$('.widget-cart-icon').html('<b>Cart </b>('+cartData.count()+')');

    validateCart(true);
    window.parent.resizeIframe(document.body.offsetHeight);
	}

	function flashMessage(str, time) {

		var name = 'flash-message';
		var hide = 'flash-message-hidden';
		var inner = 'flash-message-inner';
		if(typeof time === "undefined") time = 5000;
		var already = $('.'+name);

		if(already.length) {
			already.remove();
		}

		var el = $('<div class="'+name+' '+hide+'"><p class="'+inner+'">'+str+'</p></div>');

		el.appendTo(parent.document.body);
		setTimeout(function() { el.removeClass(hide); }, 5);
		setTimeout(function() {
			el.addClass(hide);
			setTimeout(function() { el.remove() }, 500);
		}, time);
	}

	function formatDate(d) {
		if(d instanceof Date == false) return '';
		return d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2);
	}

	function toLocaleStringSupportsOptions()
	{
		return !!(typeof Intl == 'object' && Intl && typeof Intl.NumberFormat == 'function')
	}

	function formatDateNice(date)
	{
		var dateObj = (typeof date == 'string') ? new Date(date) : date;

		if(toLocaleStringSupportsOptions()) {
			return dateObj.toLocaleString("en-nz", {
				weekday:"long",
				day:"numeric",
				month:"long",
				year:"numeric"
			});
		}

		return date;
	}

	function validName(value) {
		if(!value || value.length < 1) return false;
		return true;
		//var reg = /^[A-Za-z][A-Za-z\. \-]*$/;
		//return reg.test(value);
	}

	function validEmail(value) {
		var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
		return reg.test(value);
	}

	function validPhone(value) {
		if(!value || value.length < 6) return false;
		var reg = /^[0-9\(\)\/\+ \-]*$/;
		return reg.test(value);
	}

	function addError(el, message) {

		var par = $(el).parent();
		var error = par.find('.error');
		if(error.length) return;

		error = $('<span class="error">! '+message+'</span>');
		par.append(error);
	}

	function removeError(el) {
		$(el).siblings('.error').remove();
	}


	function Cart(inventory) {

		var self = this;
		this.inventory = inventory;
		this.nameIndex = buildIndex('name', inventory);
		this.items = {};

		var map = {
				adult: ['adult-superpass', 'family-superpass-adult'],
				child: ['child-superpass', 'family-superpass-child']
			},
			numItems = 0;
			total = 0,
			gateTotal = 0,
			familyGateTotal = 0,
			webDiscount = 0,
			familyDiscount = 0,
			aaDiscount = 0,
			adults = 0,
			children = 0;

		this.updateItem = function(id, amount) {

			var name = null;

			if(amount == 0 && this.items[id]) {
				name = this.items[id].name;
				delete this.items[id];
			}
			else if(this.inventory[id]) {
				var item = this.inventory[id];
				name = item.name;
				item.amount = amount;
				this.items[id] = item;
			}
			//console.log(this.items, amount);

					 if(name == map.adult[0]) adults = amount;
			else if(name == map.child[0]) children = amount;

			update();
			//console.log(this.getTotal(), this.getFamilyGateTotal(), this.getGateTotal(), this.getWebDiscount(), this.getFamilyDiscount());
		}

		this.validate = function()
		{
			var errors = [];

			for(var id in this.items)
			{
				var item = this.items[id],
						amount = parseInt(item.amount);

				if(amount != 0 && item.requires && item.requires.items)
				{
					var reqItems = item.requires.items,
							reqItem,
							reqName,
							reqCount = 0,
							i;

					for (i = 0; i < reqItems.length; i++)
					{
						reqName = reqItems[i];

						//could allow array value later for multiple tickets to be required
						//currently this just requires one of the items to be selected
						if(typeof reqName === 'string') {
							reqItem = this.getCartItemByName(reqName);
						}
						if(reqItem) {
							reqCount = reqCount + parseInt(reqItem.amount);
						}

					}

					if(reqCount == 0) {
						errors.push({id: item.id, name: item.name, message: item.requires.message});
					}

				}


				if(amount != 0 && item.max && item.max.including)
				{
					var including = item.max.including
					var maxTotal = item.max.value
					var maxCount = parseInt(item.amount)
					var ticketNames = ['<b>'+item.label+'</b>']

					for (var i = 0; i < including.length; i++)
					{
						var includeName = including[i];
						var includeItem = this.getCartItemByName(includeName)

						if(includeItem) {
							ticketNames.push('<b>'+includeItem.label+'</b>')
							maxCount = maxCount + parseInt(includeItem.amount)
						}
					}

					if(maxCount > maxTotal)
					{
						errors.push({
							id: item.id,
							name: item.name,
							message: 'There can only be a maximum of '+maxTotal+' tickets between '+ticketNames.join(', ')+'.'
						})
					}
				}

			}

			return errors;
		}

		this.count = function() {
			return numItems;
		}

		this.getItemTotal = function(id) {
			var item = this.items[id];
			var price = !item ? 0 : item.price_gate * item.amount;
			return formatPrice(price)
		}

		this.getTotal = function() {
			return formatPrice(total)
		}

		this.getGateTotal = function() {
			return formatPrice(gateTotal)
		}

		this.getFamilyGateTotal = function() {
			return formatPrice(familyGateTotal)
		}

		this.getWebDiscount = function() {
			return formatPrice(webDiscount)
		}

		this.getFamilyDiscount = function() {
			return formatPrice(familyDiscount)
		}

		this.getAADiscount = function() {
			return formatPrice(aaDiscount)
		}

		this.getInventoryItemByName = function(name) {
			return this.inventory[self.nameIndex[name]];
		}

		this.getCartItemByName = function(name) {
			return this.items[self.nameIndex[name]];
		}

		function formatPrice(price) {
			return '$'+(price).toFixed(2)
		}

		function update() {

			numItems = total = gateTotal = familyGateTotal = webDiscount = familyDiscount = aaDiscount = 0;
			var fam = isFamilyPass();

			for(var id in self.items) {

				var item = self.items[id];
				var web = item.price_online;
				var gate = item.price_gate;

				numItems += parseInt(item.amount);
				gateTotal += gate * item.amount;

				if(fam) {
					var name = null;

							 if(item.name == map.adult[0]) name = map.adult[1];
					else if(item.name == map.child[0]) name = map.child[1];

					if(name) {
						var deal = self.getInventoryItemByName(name);
						if(deal) {
							web = deal.price_online;
							gate = deal.price_gate;
							familyDiscount += (item.price_gate - gate) * item.amount;
						}
						else {
							fam = false;
						}
					}
				}

				//dirty custom hacks for AA deals
				if(item.name.substring(0,3) == 'aa-') {

					aaDiscount += (gate - web) * item.amount;

					var gatePrice = (gate != web) ? '<strike>'+formatPrice(gate)+'</strike> ' : '';
					var webPrice = web ? formatPrice(web) : 'Free';
					$('#'+item.name+'-price').html(gatePrice + webPrice);
				}
				else {
					webDiscount += (gate - web) * item.amount;
				}

				if(fam) familyGateTotal += gate * item.amount;
				total += web * item.amount;
				//console.log(item.label, web, item.amount, total);
			}

		}

		function isFamilyPass() {
			return (adults >= 1 && children >= 2 || adults >= 2 && children >= 1);
		}

		function buildIndex(prop, object) {
			var index = {}
			for(var key in object) {
				index[object[key][prop]] = key
			}
			return index
		}
	}

})(jQuery);

/*!
 * pickadate.js v3.6.2, 2019/03/19
 * By Amsul, http://amsul.ca
 * Hosted on http://amsul.github.io/pickadate.js
 * Licensed under MIT
 */
!function(a){"function"==typeof define&&define.amd?define("picker",["jquery"],a):"object"==typeof exports?module.exports=a(require("jquery")):this.Picker=a(jQuery)}(function(a){function b(h,i,k,m){function o(){return b._.node("div",b._.node("div",b._.node("div",b._.node("div",C.component.nodes(x.open),z.box),z.wrap),z.frame),z.holder,'tabindex="-1"')}function p(){A.data(i,C).addClass(z.input).val(A.data("value")?C.get("select",y.format):h.value).on("focus."+x.id+" click."+x.id,f(function(a){a.preventDefault(),C.open()},100)),y.editable||A.on("keydown."+x.id,v),g(h,{haspopup:!0,expanded:!1,readonly:!1,owns:h.id+"_root"})}function q(){g(C.$root[0],"hidden",!0)}function r(){C.$holder.on({keydown:v,"focus.toOpen":u,blur:function(){A.removeClass(z.target)},focusin:function(a){C.$root.removeClass(z.focused),a.stopPropagation()},"mousedown click":function(b){var c=e(b,h);c!=C.$holder[0]&&(b.stopPropagation(),"mousedown"!=b.type||a(c).is("input, select, textarea, button, option")||(b.preventDefault(),C.$holder.eq(0).focus()))}}).on("click","[data-pick], [data-nav], [data-clear], [data-close]",function(){var b=a(this),c=b.data(),d=b.hasClass(z.navDisabled)||b.hasClass(z.disabled),e=j();e=e&&(e.type||e.href?e:null),(d||e&&!a.contains(C.$root[0],e))&&C.$holder.eq(0).focus(),!d&&c.nav?C.set("highlight",C.component.item.highlight,{nav:c.nav}):!d&&"pick"in c?(C.set("select",c.pick),y.closeOnSelect&&C.close(!0)):c.clear?(C.clear(),y.closeOnClear&&C.close(!0)):c.close&&C.close(!0)})}function s(){var b;!0===y.hiddenName?(b=h.name,h.name=""):(b=["string"==typeof y.hiddenPrefix?y.hiddenPrefix:"","string"==typeof y.hiddenSuffix?y.hiddenSuffix:"_submit"],b=b[0]+h.name+b[1]),C._hidden=a('<input type=hidden name="'+b+'"'+(A.data("value")||h.value?' value="'+C.get("select",y.formatSubmit)+'"':"")+">")[0],A.on("change."+x.id,function(){C._hidden.value=h.value?C.get("select",y.formatSubmit):""})}function t(){w&&n?C.$holder.find("."+z.frame).one("transitionend",function(){C.$holder.eq(0).focus()}):setTimeout(function(){C.$holder.eq(0).focus()},0)}function u(a){a.stopPropagation(),A.addClass(z.target),C.$root.addClass(z.focused),C.open()}function v(a){var b=a.keyCode,c=/^(8|46)$/.test(b);if(27==b)return C.close(!0),!1;(32==b||c||!x.open&&C.component.key[b])&&(a.preventDefault(),a.stopPropagation(),c?C.clear().close():C.open())}if(!h)return b;var w=!1,x={id:h.id||"P"+Math.abs(~~(Math.random()*new Date))},y=k?a.extend(!0,{},k.defaults,m):m||{},z=a.extend({},b.klasses(),y.klass),A=a(h),B=function(){return this.start()},C=B.prototype={constructor:B,$node:A,start:function(){return x&&x.start?C:(x.methods={},x.start=!0,x.open=!1,x.type=h.type,h.autofocus=h==j(),h.readOnly=!y.editable,h.id=h.id||x.id,"text"!=h.type&&(h.type="text"),C.component=new k(C,y),C.$root=a('<div class="'+z.picker+'" id="'+h.id+'_root" />'),q(),C.$holder=a(o()).appendTo(C.$root),r(),y.formatSubmit&&s(),p(),y.containerHidden?a(y.containerHidden).append(C._hidden):A.after(C._hidden),y.container?a(y.container).append(C.$root):A.after(C.$root),C.on({start:C.component.onStart,render:C.component.onRender,stop:C.component.onStop,open:C.component.onOpen,close:C.component.onClose,set:C.component.onSet}).on({start:y.onStart,render:y.onRender,stop:y.onStop,open:y.onOpen,close:y.onClose,set:y.onSet}),w=c(C.$holder[0]),h.autofocus&&C.open(),C.trigger("start").trigger("render"))},render:function(b){return b?(C.$holder=a(o()),r(),C.$root.html(C.$holder)):C.$root.find("."+z.box).html(C.component.nodes(x.open)),C.trigger("render")},stop:function(){return x.start?(C.close(),C._hidden&&C._hidden.parentNode.removeChild(C._hidden),C.$root.remove(),A.removeClass(z.input).removeData(i),setTimeout(function(){A.off("."+x.id)},0),h.type=x.type,h.readOnly=!1,C.trigger("stop"),x.methods={},x.start=!1,C):C},open:function(c){return x.open?C:(A.addClass(z.active),g(h,"expanded",!0),setTimeout(function(){C.$root.addClass(z.opened),g(C.$root[0],"hidden",!1)},0),!1!==c&&(x.open=!0,w&&a("body").css("overflow","hidden").css("padding-right","+="+d()),t(),l.on("click."+x.id+" focusin."+x.id,function(a){var b=e(a,h);a.isSimulated||b==h||b==document||3==a.which||C.close(b===C.$holder[0])}).on("keydown."+x.id,function(c){var d=c.keyCode,f=C.component.key[d],g=e(c,h);27==d?C.close(!0):g!=C.$holder[0]||!f&&13!=d?a.contains(C.$root[0],g)&&13==d&&(c.preventDefault(),g.click()):(c.preventDefault(),f?b._.trigger(C.component.key.go,C,[b._.trigger(f)]):C.$root.find("."+z.highlighted).hasClass(z.disabled)||(C.set("select",C.component.item.highlight),y.closeOnSelect&&C.close(!0)))})),C.trigger("open"))},close:function(b){return b&&(y.editable?h.focus():(C.$holder.off("focus.toOpen").focus(),setTimeout(function(){C.$holder.on("focus.toOpen",u)},0))),A.removeClass(z.active),g(h,"expanded",!1),setTimeout(function(){C.$root.removeClass(z.opened+" "+z.focused),g(C.$root[0],"hidden",!0)},0),x.open?(x.open=!1,w&&a("body").css("overflow","").css("padding-right","-="+d()),l.off("."+x.id),C.trigger("close")):C},clear:function(a){return C.set("clear",null,a)},set:function(b,c,d){var e,f,g=a.isPlainObject(b),h=g?b:{};if(d=g&&a.isPlainObject(c)?c:d||{},b){g||(h[b]=c);for(e in h)f=h[e],e in C.component.item&&(void 0===f&&(f=null),C.component.set(e,f,d)),"select"!=e&&"clear"!=e||!y.updateInput||A.val("clear"==e?"":C.get(e,y.format)).trigger("change");C.render()}return d.muted?C:C.trigger("set",h)},get:function(a,c){if(a=a||"value",null!=x[a])return x[a];if("valueSubmit"==a){if(C._hidden)return C._hidden.value;a="value"}if("value"==a)return h.value;if(a in C.component.item){if("string"==typeof c){var d=C.component.get(a);return d?b._.trigger(C.component.formats.toString,C.component,[c,d]):""}return C.component.get(a)}},on:function(b,c,d){var e,f,g=a.isPlainObject(b),h=g?b:{};if(b){g||(h[b]=c);for(e in h)f=h[e],d&&(e="_"+e),x.methods[e]=x.methods[e]||[],x.methods[e].push(f)}return C},off:function(){var a,b,c=arguments;for(a=0,namesCount=c.length;a<namesCount;a+=1)(b=c[a])in x.methods&&delete x.methods[b];return C},trigger:function(a,c){var d=function(a){var d=x.methods[a];d&&d.map(function(a){b._.trigger(a,C,[c])})};return d("_"+a),d(a),C}};return new B}function c(a){var b,c="position";return a.currentStyle?b=a.currentStyle[c]:window.getComputedStyle&&(b=getComputedStyle(a)[c]),"fixed"==b}function d(){if(m.height()<=k.height())return 0;var b=a('<div style="visibility:hidden;width:100px" />').appendTo("body"),c=b[0].offsetWidth;b.css("overflow","scroll");var d=a('<div style="width:100%" />').appendTo(b),e=d[0].offsetWidth;return b.remove(),c-e}function e(a,b){var c=[];return a.path&&(c=a.path),a.originalEvent&&a.originalEvent.path&&(c=a.originalEvent.path),c&&c.length>0?b&&c.indexOf(b)>=0?b:c[0]:a.target}function f(a,b,c){var d;return function(){var e=this,f=arguments,g=function(){d=null,c||a.apply(e,f)},h=c&&!d;clearTimeout(d),d=setTimeout(g,b),h&&a.apply(e,f)}}function g(b,c,d){if(a.isPlainObject(c))for(var e in c)h(b,e,c[e]);else h(b,c,d)}function h(a,b,c){a.setAttribute(("role"==b?"":"aria-")+b,c)}function i(b,c){a.isPlainObject(b)||(b={attribute:c}),c="";for(var d in b){var e=("role"==d?"":"aria-")+d;c+=null==b[d]?"":e+'="'+b[d]+'"'}return c}function j(){try{return document.activeElement}catch(a){}}var k=a(window),l=a(document),m=a(document.documentElement),n=null!=document.documentElement.style.transition;return b.klasses=function(a){return a=a||"picker",{picker:a,opened:a+"--opened",focused:a+"--focused",input:a+"__input",active:a+"__input--active",target:a+"__input--target",holder:a+"__holder",frame:a+"__frame",wrap:a+"__wrap",box:a+"__box"}},b._={group:function(a){for(var c,d="",e=b._.trigger(a.min,a);e<=b._.trigger(a.max,a,[e]);e+=a.i)c=b._.trigger(a.item,a,[e]),d+=b._.node(a.node,c[0],c[1],c[2]);return d},node:function(b,c,d,e){return c?(c=a.isArray(c)?c.join(""):c,d=d?' class="'+d+'"':"",e=e?" "+e:"","<"+b+d+e+">"+c+"</"+b+">"):""},lead:function(a){return(a<10?"0":"")+a},trigger:function(a,b,c){return"function"==typeof a?a.apply(b,c||[]):a},digits:function(a){return/\d/.test(a[1])?2:1},isDate:function(a){return{}.toString.call(a).indexOf("Date")>-1&&this.isInteger(a.getDate())},isInteger:function(a){return{}.toString.call(a).indexOf("Number")>-1&&a%1==0},ariaAttr:i},b.extend=function(c,d){a.fn[c]=function(e,f){var g=this.data(c);return"picker"==e?g:g&&"string"==typeof e?b._.trigger(g[e],g,[f]):this.each(function(){a(this).data(c)||new b(this,c,d,e)})},a.fn[c].defaults=d.defaults},b});
/*!
 * Date picker for pickadate.js v3.6.2
 * http://amsul.github.io/pickadate.js/date.htm
 */
!function(a){"function"==typeof define&&define.amd?define(["./picker","jquery"],a):"object"==typeof exports?module.exports=a(require("./picker.js"),require("jquery")):a(Picker,jQuery)}(function(a,b){function c(a,b){var c=this,d=a.$node[0],e=d.value,f=a.$node.data("value"),g=f||e,h=f?b.formatSubmit:b.format,i=function(){return d.currentStyle?"rtl"==d.currentStyle.direction:"rtl"==getComputedStyle(a.$root[0]).direction};c.settings=b,c.$node=a.$node,c.queue={min:"measure create",max:"measure create",now:"now create",select:"parse create validate",highlight:"parse navigate create validate",view:"parse create validate viewset",disable:"deactivate",enable:"activate"},c.item={},c.item.clear=null,c.item.disable=(b.disable||[]).slice(0),c.item.enable=-function(a){return!0===a[0]?a.shift():-1}(c.item.disable),c.set("min",b.min).set("max",b.max).set("now"),g?c.set("select",g,{format:h,defaultValue:!0}):c.set("select",null).set("highlight",c.item.now),c.key={40:7,38:-7,39:function(){return i()?-1:1},37:function(){return i()?1:-1},go:function(a){var b=c.item.highlight,d=new Date(b.year,b.month,b.date+a);c.set("highlight",d,{interval:a}),this.render()}},a.on("render",function(){a.$root.find("."+b.klass.selectMonth).on("change",function(){var c=this.value;c&&(a.set("highlight",[a.get("view").year,c,a.get("highlight").date]),a.$root.find("."+b.klass.selectMonth).trigger("focus"))}),a.$root.find("."+b.klass.selectYear).on("change",function(){var c=this.value;c&&(a.set("highlight",[c,a.get("view").month,a.get("highlight").date]),a.$root.find("."+b.klass.selectYear).trigger("focus"))})},1).on("open",function(){var d="";c.disabled(c.get("now"))&&(d=":not(."+b.klass.buttonToday+")"),a.$root.find("button"+d+", select").attr("disabled",!1)},1).on("close",function(){a.$root.find("button, select").attr("disabled",!0)},1)}var d=7,e=a._;c.prototype.set=function(a,b,c){var d=this,e=d.item;return null===b?("clear"==a&&(a="select"),e[a]=b,d):(e["enable"==a?"disable":"flip"==a?"enable":a]=d.queue[a].split(" ").map(function(e){return b=d[e](a,b,c)}).pop(),"select"==a?d.set("highlight",e.select,c):"highlight"==a?d.set("view",e.highlight,c):a.match(/^(flip|min|max|disable|enable)$/)&&(e.select&&d.disabled(e.select)&&d.set("select",e.select,c),e.highlight&&d.disabled(e.highlight)&&d.set("highlight",e.highlight,c)),d)},c.prototype.get=function(a){return this.item[a]},c.prototype.create=function(a,c,d){var f,g=this;return c=void 0===c?a:c,c==-1/0||c==1/0?f=c:b.isPlainObject(c)&&e.isInteger(c.pick)?c=c.obj:b.isArray(c)?(c=new Date(c[0],c[1],c[2]),c=e.isDate(c)?c:g.create().obj):c=e.isInteger(c)||e.isDate(c)?g.normalize(new Date(c),d):g.now(a,c,d),{year:f||c.getFullYear(),month:f||c.getMonth(),date:f||c.getDate(),day:f||c.getDay(),obj:f||c,pick:f||c.getTime()}},c.prototype.createRange=function(a,c){var d=this,f=function(a){return!0===a||b.isArray(a)||e.isDate(a)?d.create(a):a};return e.isInteger(a)||(a=f(a)),e.isInteger(c)||(c=f(c)),e.isInteger(a)&&b.isPlainObject(c)?a=[c.year,c.month,c.date+a]:e.isInteger(c)&&b.isPlainObject(a)&&(c=[a.year,a.month,a.date+c]),{from:f(a),to:f(c)}},c.prototype.withinRange=function(a,b){return a=this.createRange(a.from,a.to),b.pick>=a.from.pick&&b.pick<=a.to.pick},c.prototype.overlapRanges=function(a,b){var c=this;return a=c.createRange(a.from,a.to),b=c.createRange(b.from,b.to),c.withinRange(a,b.from)||c.withinRange(a,b.to)||c.withinRange(b,a.from)||c.withinRange(b,a.to)},c.prototype.now=function(a,b,c){return b=new Date,c&&c.rel&&b.setDate(b.getDate()+c.rel),this.normalize(b,c)},c.prototype.navigate=function(a,c,d){var e,f,g,h,i=b.isArray(c),j=b.isPlainObject(c),k=this.item.view;if(i||j){for(j?(f=c.year,g=c.month,h=c.date):(f=+c[0],g=+c[1],h=+c[2]),d&&d.nav&&k&&k.month!==g&&(f=k.year,g=k.month),e=new Date(f,g+(d&&d.nav?d.nav:0),1),f=e.getFullYear(),g=e.getMonth();new Date(f,g,h).getMonth()!==g;)h-=1;c=[f,g,h]}return c},c.prototype.normalize=function(a){return a.setHours(0,0,0,0),a},c.prototype.measure=function(a,b){var c=this;return e.isInteger(b)?b=c.now(a,b,{rel:b}):b?"string"==typeof b&&(b=c.parse(a,b)):b="min"==a?-1/0:1/0,b},c.prototype.viewset=function(a,b){return this.create([b.year,b.month,1])},c.prototype.validate=function(a,c,d){var f,g,h,i,j=this,k=c,l=d&&d.interval?d.interval:1,m=-1===j.item.enable,n=j.item.min,o=j.item.max,p=m&&j.item.disable.filter(function(a){if(b.isArray(a)){var d=j.create(a).pick;d<c.pick?f=!0:d>c.pick&&(g=!0)}return e.isInteger(a)}).length;if((!d||!d.nav&&!d.defaultValue)&&(!m&&j.disabled(c)||m&&j.disabled(c)&&(p||f||g)||!m&&(c.pick<=n.pick||c.pick>=o.pick)))for(m&&!p&&(!g&&l>0||!f&&l<0)&&(l*=-1);j.disabled(c)&&(Math.abs(l)>1&&(c.month<k.month||c.month>k.month)&&(c=k,l=l>0?1:-1),c.pick<=n.pick?(h=!0,l=1,c=j.create([n.year,n.month,n.date+(c.pick===n.pick?0:-1)])):c.pick>=o.pick&&(i=!0,l=-1,c=j.create([o.year,o.month,o.date+(c.pick===o.pick?0:1)])),!h||!i);)c=j.create([c.year,c.month,c.date+l]);return c},c.prototype.disabled=function(a){var c=this,d=c.item.disable.filter(function(d){return e.isInteger(d)?a.day===(c.settings.firstDay?d:d-1)%7:b.isArray(d)||e.isDate(d)?a.pick===c.create(d).pick:b.isPlainObject(d)?c.withinRange(d,a):void 0});return d=d.length&&!d.filter(function(a){return b.isArray(a)&&"inverted"==a[3]||b.isPlainObject(a)&&a.inverted}).length,-1===c.item.enable?!d:d||a.pick<c.item.min.pick||a.pick>c.item.max.pick},c.prototype.parse=function(a,b,c){var d=this,f={};return b&&"string"==typeof b?(c&&c.format||(c=c||{},c.format=d.settings.format),d.formats.toArray(c.format).map(function(a){var c=d.formats[a],g=c?e.trigger(c,d,[b,f]):a.replace(/^!/,"").length;c&&(f[a]=b.substr(0,g)),b=b.substr(g)}),[f.yyyy||f.yy,+(f.mm||f.m)-1,f.dd||f.d]):b},c.prototype.formats=function(){function a(a,b,c){var d=a.match(/[^\x00-\x7F]+|\w+/)[0];return c.mm||c.m||(c.m=b.indexOf(d)+1),d.length}function b(a){return a.match(/\w+/)[0].length}return{d:function(a,b){return a?e.digits(a):b.date},dd:function(a,b){return a?2:e.lead(b.date)},ddd:function(a,c){return a?b(a):this.settings.weekdaysShort[c.day]},dddd:function(a,c){return a?b(a):this.settings.weekdaysFull[c.day]},m:function(a,b){return a?e.digits(a):b.month+1},mm:function(a,b){return a?2:e.lead(b.month+1)},mmm:function(b,c){var d=this.settings.monthsShort;return b?a(b,d,c):d[c.month]},mmmm:function(b,c){var d=this.settings.monthsFull;return b?a(b,d,c):d[c.month]},yy:function(a,b){return a?2:(""+b.year).slice(2)},yyyy:function(a,b){return a?4:b.year},toArray:function(a){return a.split(/(d{1,4}|m{1,4}|y{4}|yy|!.)/g)},toString:function(a,b){var c=this;return c.formats.toArray(a).map(function(a){return e.trigger(c.formats[a],c,[0,b])||a.replace(/^!/,"")}).join("")}}}(),c.prototype.isDateExact=function(a,c){var d=this;return e.isInteger(a)&&e.isInteger(c)||"boolean"==typeof a&&"boolean"==typeof c?a===c:(e.isDate(a)||b.isArray(a))&&(e.isDate(c)||b.isArray(c))?d.create(a).pick===d.create(c).pick:!(!b.isPlainObject(a)||!b.isPlainObject(c))&&d.isDateExact(a.from,c.from)&&d.isDateExact(a.to,c.to)},c.prototype.isDateOverlap=function(a,c){var d=this,f=d.settings.firstDay?1:0;return e.isInteger(a)&&(e.isDate(c)||b.isArray(c))?(a=a%7+f)===d.create(c).day+1:e.isInteger(c)&&(e.isDate(a)||b.isArray(a))?(c=c%7+f)===d.create(a).day+1:!(!b.isPlainObject(a)||!b.isPlainObject(c))&&d.overlapRanges(a,c)},c.prototype.flipEnable=function(a){var b=this.item;b.enable=a||(-1==b.enable?1:-1)},c.prototype.deactivate=function(a,c){var d=this,f=d.item.disable.slice(0);return"flip"==c?d.flipEnable():!1===c?(d.flipEnable(1),f=[]):!0===c?(d.flipEnable(-1),f=[]):c.map(function(a){for(var c,g=0;g<f.length;g+=1)if(d.isDateExact(a,f[g])){c=!0;break}c||(e.isInteger(a)||e.isDate(a)||b.isArray(a)||b.isPlainObject(a)&&a.from&&a.to)&&f.push(a)}),f},c.prototype.activate=function(a,c){var d=this,f=d.item.disable,g=f.length;return"flip"==c?d.flipEnable():!0===c?(d.flipEnable(1),f=[]):!1===c?(d.flipEnable(-1),f=[]):c.map(function(a){var c,h,i,j;for(i=0;i<g;i+=1){if(h=f[i],d.isDateExact(h,a)){c=f[i]=null,j=!0;break}if(d.isDateOverlap(h,a)){b.isPlainObject(a)?(a.inverted=!0,c=a):b.isArray(a)?(c=a,c[3]||c.push("inverted")):e.isDate(a)&&(c=[a.getFullYear(),a.getMonth(),a.getDate(),"inverted"]);break}}if(c)for(i=0;i<g;i+=1)if(d.isDateExact(f[i],a)){f[i]=null;break}if(j)for(i=0;i<g;i+=1)if(d.isDateOverlap(f[i],a)){f[i]=null;break}c&&f.push(c)}),f.filter(function(a){return null!=a})},c.prototype.nodes=function(a){var b=this,c=b.settings,f=b.item,g=f.now,h=f.select,i=f.highlight,j=f.view,k=f.disable,l=f.min,m=f.max,n=function(a,b){return c.firstDay&&(a.push(a.shift()),b.push(b.shift())),e.node("thead",e.node("tr",e.group({min:0,max:d-1,i:1,node:"th",item:function(d){return[a[d],c.klass.weekdays,'scope=col title="'+b[d]+'"']}})))}((c.showWeekdaysFull?c.weekdaysFull:c.weekdaysShort).slice(0),c.weekdaysFull.slice(0)),o=function(a){return e.node("div"," ",c.klass["nav"+(a?"Next":"Prev")]+(a&&j.year>=m.year&&j.month>=m.month||!a&&j.year<=l.year&&j.month<=l.month?" "+c.klass.navDisabled:""),"data-nav="+(a||-1)+" "+e.ariaAttr({role:"button",controls:b.$node[0].id+"_table"})+' title="'+(a?c.labelMonthNext:c.labelMonthPrev)+'"')},p=function(){var d=c.showMonthsShort?c.monthsShort:c.monthsFull;return c.selectMonths?e.node("select",e.group({min:0,max:11,i:1,node:"option",item:function(a){return[d[a],0,"value="+a+(j.month==a?" selected":"")+(j.year==l.year&&a<l.month||j.year==m.year&&a>m.month?" disabled":"")]}}),c.klass.selectMonth,(a?"":"disabled")+" "+e.ariaAttr({controls:b.$node[0].id+"_table"})+' title="'+c.labelMonthSelect+'"'):e.node("div",d[j.month],c.klass.month)},q=function(){var d=j.year,f=!0===c.selectYears?5:~~(c.selectYears/2);if(f){var g=l.year,h=m.year,i=d-f,k=d+f;if(g>i&&(k+=g-i,i=g),h<k){var n=i-g,o=k-h;i-=n>o?o:n,k=h}return e.node("select",e.group({min:i,max:k,i:1,node:"option",item:function(a){return[a,0,"value="+a+(d==a?" selected":"")]}}),c.klass.selectYear,(a?"":"disabled")+" "+e.ariaAttr({controls:b.$node[0].id+"_table"})+' title="'+c.labelYearSelect+'"')}return e.node("div",d,c.klass.year)};return e.node("div",(c.selectYears?q()+p():p()+q())+o()+o(1),c.klass.header)+e.node("table",n+e.node("tbody",e.group({min:0,max:5,i:1,node:"tr",item:function(a){var f=c.firstDay&&0===b.create([j.year,j.month,1]).day?-7:0;return[e.group({min:d*a-j.day+f+1,max:function(){return this.min+d-1},i:1,node:"td",item:function(a){a=b.create([j.year,j.month,a+(c.firstDay?1:0)]);var d=h&&h.pick==a.pick,f=i&&i.pick==a.pick,n=k&&b.disabled(a)||a.pick<l.pick||a.pick>m.pick,o=e.trigger(b.formats.toString,b,[c.format,a]);return[e.node("div",a.date,function(b){return b.push(j.month==a.month?c.klass.infocus:c.klass.outfocus),g.pick==a.pick&&b.push(c.klass.now),d&&b.push(c.klass.selected),f&&b.push(c.klass.highlighted),n&&b.push(c.klass.disabled),b.join(" ")}([c.klass.day]),"data-pick="+a.pick+" "+e.ariaAttr({role:"gridcell",label:o,selected:!(!d||b.$node.val()!==o)||null,activedescendant:!!f||null,disabled:!!n||null})),"",e.ariaAttr({role:"presentation"})]}})]}})),c.klass.table,'id="'+b.$node[0].id+'_table" '+e.ariaAttr({role:"grid",controls:b.$node[0].id,readonly:!0}))+e.node("div",e.node("button",c.today,c.klass.buttonToday,"type=button data-pick="+g.pick+(a&&!b.disabled(g)?"":" disabled")+" "+e.ariaAttr({controls:b.$node[0].id}))+e.node("button",c.clear,c.klass.buttonClear,"type=button data-clear=1"+(a?"":" disabled")+" "+e.ariaAttr({controls:b.$node[0].id}))+e.node("button",c.close,c.klass.buttonClose,"type=button data-close=true "+(a?"":" disabled")+" "+e.ariaAttr({controls:b.$node[0].id})),c.klass.footer)},c.defaults=function(a){return{labelMonthNext:"Next month",labelMonthPrev:"Previous month",labelMonthSelect:"Select a month",labelYearSelect:"Select a year",monthsFull:["January","February","March","April","May","June","July","August","September","October","November","December"],monthsShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],weekdaysFull:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],weekdaysShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],today:"Today",clear:"Clear",close:"Close",closeOnSelect:!0,closeOnClear:!0,updateInput:!0,format:"d mmmm, yyyy",klass:{table:a+"table",header:a+"header",navPrev:a+"nav--prev",navNext:a+"nav--next",navDisabled:a+"nav--disabled",month:a+"month",year:a+"year",selectMonth:a+"select--month",selectYear:a+"select--year",weekdays:a+"weekday",day:a+"day",disabled:a+"day--disabled",selected:a+"day--selected",highlighted:a+"day--highlighted",now:a+"day--today",infocus:a+"day--infocus",outfocus:a+"day--outfocus",footer:a+"footer",buttonClear:a+"button--clear",buttonToday:a+"button--today",buttonClose:a+"button--close"}}}(a.klasses().picker+"__"),a.extend("pickadate",c)});
/*!
 * Legacy browser support
 */
[].map||(Array.prototype.map=function(a,b){for(var c=this,d=c.length,e=new Array(d),f=0;f<d;f++)f in c&&(e[f]=a.call(b,c[f],f,c));return e}),[].filter||(Array.prototype.filter=function(a){if(null==this)throw new TypeError;var b=Object(this),c=b.length>>>0;if("function"!=typeof a)throw new TypeError;for(var d=[],e=arguments[1],f=0;f<c;f++)if(f in b){var g=b[f];a.call(e,g,f,b)&&d.push(g)}return d}),[].indexOf||(Array.prototype.indexOf=function(a){if(null==this)throw new TypeError;var b=Object(this),c=b.length>>>0;if(0===c)return-1;var d=0;if(arguments.length>1&&(d=Number(arguments[1]),d!=d?d=0:0!==d&&d!=1/0&&d!=-1/0&&(d=(d>0||-1)*Math.floor(Math.abs(d)))),d>=c)return-1;for(var e=d>=0?d:Math.max(c-Math.abs(d),0);e<c;e++)if(e in b&&b[e]===a)return e;return-1});
/*!
 * Cross-Browser Split 1.1.1
 * Copyright 2007-2012 Steven Levithan <stevenlevithan.com>
 * Available under the MIT License
 * http://blog.stevenlevithan.com/archives/cross-browser-split
 */
var nativeSplit=String.prototype.split,compliantExecNpcg=void 0===/()??/.exec("")[1];String.prototype.split=function(a,b){var c=this;if("[object RegExp]"!==Object.prototype.toString.call(a))return nativeSplit.call(c,a,b);var d,e,f,g,h=[],i=(a.ignoreCase?"i":"")+(a.multiline?"m":"")+(a.extended?"x":"")+(a.sticky?"y":""),j=0;for(a=new RegExp(a.source,i+"g"),c+="",compliantExecNpcg||(d=new RegExp("^"+a.source+"$(?!\\s)",i)),b=void 0===b?-1>>>0:b>>>0;(e=a.exec(c))&&!((f=e.index+e[0].length)>j&&(h.push(c.slice(j,e.index)),!compliantExecNpcg&&e.length>1&&e[0].replace(d,function(){for(var a=1;a<arguments.length-2;a++)void 0===arguments[a]&&(e[a]=void 0)}),e.length>1&&e.index<c.length&&Array.prototype.push.apply(h,e.slice(1)),g=e[0].length,j=f,h.length>=b));)a.lastIndex===e.index&&a.lastIndex++;return j===c.length?!g&&a.test("")||h.push(""):h.push(c.slice(j)),h.length>b?h.slice(0,b):h};

/*!
 * Bootstrap v3.3.1 (http://getbootstrap.com) Tooltip
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */
if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(t){var e=t.fn.jquery.split(" ")[0].split(".");if(e[0]<2&&e[1]<9||1==e[0]&&9==e[1]&&e[2]<1)throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher")}(jQuery),+function(t){"use strict";function e(e){return this.each(function(){var i=t(this),s=i.data("bs.tooltip"),n="object"==typeof e&&e,r=n&&n.selector;(s||"destroy"!=e)&&(r?(s||i.data("bs.tooltip",s={}),s[r]||(s[r]=new o(this,n))):s||i.data("bs.tooltip",s=new o(this,n)),"string"==typeof e&&s[e]())})}var o=function(t,e){this.type=this.options=this.enabled=this.timeout=this.hoverState=this.$element=null,this.init("tooltip",t,e)};o.VERSION="3.3.1",o.TRANSITION_DURATION=150,o.DEFAULTS={animation:!0,placement:"top",selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,container:!1,viewport:{selector:"body",padding:0}},o.prototype.init=function(e,o,i){this.enabled=!0,this.type=e,this.$element=t(o),this.options=this.getOptions(i),this.$viewport=this.options.viewport&&t(this.options.viewport.selector||this.options.viewport);for(var s=this.options.trigger.split(" "),n=s.length;n--;){var r=s[n];if("click"==r)this.$element.on("click."+this.type,this.options.selector,t.proxy(this.toggle,this));else if("manual"!=r){var a="hover"==r?"mouseenter":"focusin",p="hover"==r?"mouseleave":"focusout";this.$element.on(a+"."+this.type,this.options.selector,t.proxy(this.enter,this)),this.$element.on(p+"."+this.type,this.options.selector,t.proxy(this.leave,this))}}this.options.selector?this._options=t.extend({},this.options,{trigger:"manual",selector:""}):this.fixTitle()},o.prototype.getDefaults=function(){return o.DEFAULTS},o.prototype.getOptions=function(e){return e=t.extend({},this.getDefaults(),this.$element.data(),e),e.delay&&"number"==typeof e.delay&&(e.delay={show:e.delay,hide:e.delay}),e},o.prototype.getDelegateOptions=function(){var e={},o=this.getDefaults();return this._options&&t.each(this._options,function(t,i){o[t]!=i&&(e[t]=i)}),e},o.prototype.enter=function(e){var o=e instanceof this.constructor?e:t(e.currentTarget).data("bs."+this.type);return o&&o.$tip&&o.$tip.is(":visible")?void(o.hoverState="in"):(o||(o=new this.constructor(e.currentTarget,this.getDelegateOptions()),t(e.currentTarget).data("bs."+this.type,o)),clearTimeout(o.timeout),o.hoverState="in",o.options.delay&&o.options.delay.show?void(o.timeout=setTimeout(function(){"in"==o.hoverState&&o.show()},o.options.delay.show)):o.show())},o.prototype.leave=function(e){var o=e instanceof this.constructor?e:t(e.currentTarget).data("bs."+this.type);return o||(o=new this.constructor(e.currentTarget,this.getDelegateOptions()),t(e.currentTarget).data("bs."+this.type,o)),clearTimeout(o.timeout),o.hoverState="out",o.options.delay&&o.options.delay.hide?void(o.timeout=setTimeout(function(){"out"==o.hoverState&&o.hide()},o.options.delay.hide)):o.hide()},o.prototype.show=function(){var e=t.Event("show.bs."+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(e);var i=t.contains(this.$element[0].ownerDocument.documentElement,this.$element[0]);if(e.isDefaultPrevented()||!i)return;var s=this,n=this.tip(),r=this.getUID(this.type);this.setContent(),n.attr("id",r),this.$element.attr("aria-describedby",r),this.options.animation&&n.addClass("fade");var a="function"==typeof this.options.placement?this.options.placement.call(this,n[0],this.$element[0]):this.options.placement,p=/\s?auto?\s?/i,l=p.test(a);l&&(a=a.replace(p,"")||"top"),n.detach().css({top:0,left:0,display:"block"}).addClass(a).data("bs."+this.type,this),this.options.container?n.appendTo(this.options.container):n.insertAfter(this.$element);var h=this.getPosition(),f=n[0].offsetWidth,u=n[0].offsetHeight;if(l){var c=a,d=this.options.container?t(this.options.container):this.$element.parent(),g=this.getPosition(d);a="bottom"==a&&h.bottom+u>g.bottom?"top":"top"==a&&h.top-u<g.top?"bottom":"right"==a&&h.right+f>g.width?"left":"left"==a&&h.left-f<g.left?"right":a,n.removeClass(c).addClass(a)}var v=this.getCalculatedOffset(a,h,f,u);this.applyPlacement(v,a);var y=function(){var t=s.hoverState;s.$element.trigger("shown.bs."+s.type),s.hoverState=null,"out"==t&&s.leave(s)};t.support.transition&&this.$tip.hasClass("fade")?n.one("bsTransitionEnd",y).emulateTransitionEnd(o.TRANSITION_DURATION):y()}},o.prototype.applyPlacement=function(e,o){var i=this.tip(),s=i[0].offsetWidth,n=i[0].offsetHeight,r=parseInt(i.css("margin-top"),10),a=parseInt(i.css("margin-left"),10);isNaN(r)&&(r=0),isNaN(a)&&(a=0),e.top=e.top+r,e.left=e.left+a,t.offset.setOffset(i[0],t.extend({using:function(t){i.css({top:Math.round(t.top),left:Math.round(t.left)})}},e),0),i.addClass("in");var p=i[0].offsetWidth,l=i[0].offsetHeight;"top"==o&&l!=n&&(e.top=e.top+n-l);var h=this.getViewportAdjustedDelta(o,e,p,l);h.left?e.left+=h.left:e.top+=h.top;var f=/top|bottom/.test(o),u=f?2*h.left-s+p:2*h.top-n+l,c=f?"offsetWidth":"offsetHeight";i.offset(e),this.replaceArrow(u,i[0][c],f)},o.prototype.replaceArrow=function(t,e,o){this.arrow().css(o?"left":"top",50*(1-t/e)+"%").css(o?"top":"left","")},o.prototype.setContent=function(){var t=this.tip(),e=this.getTitle();t.find(".tooltip-inner")[this.options.html?"html":"text"](e),t.removeClass("fade in top bottom left right")},o.prototype.hide=function(e){function i(){"in"!=s.hoverState&&n.detach(),s.$element.removeAttr("aria-describedby").trigger("hidden.bs."+s.type),e&&e()}var s=this,n=this.tip(),r=t.Event("hide.bs."+this.type);return this.$element.trigger(r),r.isDefaultPrevented()?void 0:(n.removeClass("in"),t.support.transition&&this.$tip.hasClass("fade")?n.one("bsTransitionEnd",i).emulateTransitionEnd(o.TRANSITION_DURATION):i(),this.hoverState=null,this)},o.prototype.fixTitle=function(){var t=this.$element;(t.attr("title")||"string"!=typeof t.attr("data-original-title"))&&t.attr("data-original-title",t.attr("title")||"").attr("title","")},o.prototype.hasContent=function(){return this.getTitle()},o.prototype.getPosition=function(e){e=e||this.$element;var o=e[0],i="BODY"==o.tagName,s=o.getBoundingClientRect();null==s.width&&(s=t.extend({},s,{width:s.right-s.left,height:s.bottom-s.top}));var n=i?{top:0,left:0}:e.offset(),r={scroll:i?document.documentElement.scrollTop||document.body.scrollTop:e.scrollTop()},a=i?{width:t(window).width(),height:t(window).height()}:null;return t.extend({},s,r,a,n)},o.prototype.getCalculatedOffset=function(t,e,o,i){return"bottom"==t?{top:e.top+e.height,left:e.left+e.width/2-o/2}:"top"==t?{top:e.top-i,left:e.left+e.width/2-o/2}:"left"==t?{top:e.top+e.height/2-i/2,left:e.left-o}:{top:e.top+e.height/2-i/2,left:e.left+e.width}},o.prototype.getViewportAdjustedDelta=function(t,e,o,i){var s={top:0,left:0};if(!this.$viewport)return s;var n=this.options.viewport&&this.options.viewport.padding||0,r=this.getPosition(this.$viewport);if(/right|left/.test(t)){var a=e.top-n-r.scroll,p=e.top+n-r.scroll+i;a<r.top?s.top=r.top-a:p>r.top+r.height&&(s.top=r.top+r.height-p)}else{var l=e.left-n,h=e.left+n+o;l<r.left?s.left=r.left-l:h>r.width&&(s.left=r.left+r.width-h)}return s},o.prototype.getTitle=function(){var t,e=this.$element,o=this.options;return t=e.attr("data-original-title")||("function"==typeof o.title?o.title.call(e[0]):o.title)},o.prototype.getUID=function(t){do t+=~~(1e6*Math.random());while(document.getElementById(t));return t},o.prototype.tip=function(){return this.$tip=this.$tip||t(this.options.template)},o.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".tooltip-arrow")},o.prototype.enable=function(){this.enabled=!0},o.prototype.disable=function(){this.enabled=!1},o.prototype.toggleEnabled=function(){this.enabled=!this.enabled},o.prototype.toggle=function(e){var o=this;e&&(o=t(e.currentTarget).data("bs."+this.type),o||(o=new this.constructor(e.currentTarget,this.getDelegateOptions()),t(e.currentTarget).data("bs."+this.type,o))),o.tip().hasClass("in")?o.leave(o):o.enter(o)},o.prototype.destroy=function(){var t=this;clearTimeout(this.timeout),this.hide(function(){t.$element.off("."+t.type).removeData("bs."+t.type)})};var i=t.fn.tooltip;t.fn.tooltip=e,t.fn.tooltip.Constructor=o,t.fn.tooltip.noConflict=function(){return t.fn.tooltip=i,this}}(jQuery);

// jQuery Mask Plugin v1.14.11
// github.com/igorescobar/jQuery-Mask-Plugin
var $jscomp={scope:{},findInternal:function(a,l,d){a instanceof String&&(a=String(a));for(var p=a.length,h=0;h<p;h++){var b=a[h];if(l.call(d,b,h,a))return{i:h,v:b}}return{i:-1,v:void 0}}};$jscomp.defineProperty="function"==typeof Object.defineProperties?Object.defineProperty:function(a,l,d){if(d.get||d.set)throw new TypeError("ES3 does not support getters and setters.");a!=Array.prototype&&a!=Object.prototype&&(a[l]=d.value)};$jscomp.getGlobal=function(a){return"undefined"!=typeof window&&window===a?a:"undefined"!=typeof global&&null!=global?global:a};$jscomp.global=$jscomp.getGlobal(this);$jscomp.polyfill=function(a,l,d,p){if(l){d=$jscomp.global;a=a.split(".");for(p=0;p<a.length-1;p++){var h=a[p];h in d||(d[h]={});d=d[h]}a=a[a.length-1];p=d[a];l=l(p);l!=p&&null!=l&&$jscomp.defineProperty(d,a,{configurable:!0,writable:!0,value:l})}};$jscomp.polyfill("Array.prototype.find",function(a){return a?a:function(a,d){return $jscomp.findInternal(this,a,d).v}},"es6-impl","es3");(function(a,l,d){"function"===typeof define&&define.amd?define(["jquery"],a):"object"===typeof exports?module.exports=a(require("jquery")):a(l||d)})(function(a){var l=function(b,e,f){var c={invalid:[],getCaret:function(){try{var a,r=0,g=b.get(0),e=document.selection,f=g.selectionStart;if(e&&-1===navigator.appVersion.indexOf("MSIE 10"))a=e.createRange(),a.moveStart("character",-c.val().length),r=a.text.length;else if(f||"0"===f)r=f;return r}catch(C){}},setCaret:function(a){try{if(b.is(":focus")){var c,g=b.get(0);g.setSelectionRange?g.setSelectionRange(a,a):(c=g.createTextRange(),c.collapse(!0),c.moveEnd("character",a),c.moveStart("character",a),c.select())}}catch(B){}},events:function(){b.on("keydown.mask",function(a){b.data("mask-keycode",a.keyCode||a.which);b.data("mask-previus-value",b.val());b.data("mask-previus-caret-pos",c.getCaret());c.maskDigitPosMapOld=c.maskDigitPosMap}).on(a.jMaskGlobals.useInput?"input.mask":"keyup.mask",c.behaviour).on("paste.mask drop.mask",function(){setTimeout(function(){b.keydown().keyup()},100)}).on("change.mask",function(){b.data("changed",!0)}).on("blur.mask",function(){d===c.val()||b.data("changed")||b.trigger("change");b.data("changed",!1)}).on("blur.mask",function(){d=c.val()}).on("focus.mask",function(b){!0===f.selectOnFocus&&a(b.target).select()}).on("focusout.mask",function(){f.clearIfNotMatch&&!h.test(c.val())&&c.val("")})},getRegexMask:function(){for(var a=[],b,c,f,n,d=0;d<e.length;d++)(b=m.translation[e.charAt(d)])?(c=b.pattern.toString().replace(/.{1}$|^.{1}/g,""),f=b.optional,(b=b.recursive)?(a.push(e.charAt(d)),n={digit:e.charAt(d),pattern:c}):a.push(f||b?c+"?":c)):a.push(e.charAt(d).replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&"));a=a.join("");n&&(a=a.replace(new RegExp("("+n.digit+"(.*"+n.digit+")?)"),"($1)?").replace(new RegExp(n.digit,"g"),n.pattern));return new RegExp(a)},destroyEvents:function(){b.off("input keydown keyup paste drop blur focusout ".split(" ").join(".mask "))},val:function(a){var c=b.is("input")?"val":"text";if(0<arguments.length){if(b[c]()!==a)b[c](a);c=b}else c=b[c]();return c},calculateCaretPosition:function(){var a=b.data("mask-previus-value")||"",e=c.getMasked(),g=c.getCaret();if(a!==e){var f=b.data("mask-previus-caret-pos")||0,e=e.length,d=a.length,m=a=0,h=0,l=0,k;for(k=g;k<e&&c.maskDigitPosMap[k];k++)m++;for(k=g-1;0<=k&&c.maskDigitPosMap[k];k--)a++;for(k=g-1;0<=k;k--)c.maskDigitPosMap[k]&&h++;for(k=f-1;0<=k;k--)c.maskDigitPosMapOld[k]&&l++;g>d?g=e:f>=g&&f!==d?c.maskDigitPosMapOld[g]||(f=g,g=g-(l-h)-a,c.maskDigitPosMap[g]&&(g=f)):g>f&&(g=g+(h-l)+m)}return g},behaviour:function(f){f=f||window.event;c.invalid=[];var e=b.data("mask-keycode");if(-1===a.inArray(e,m.byPassKeys)){var e=c.getMasked(),g=c.getCaret();setTimeout(function(){c.setCaret(c.calculateCaretPosition())},10);c.val(e);c.setCaret(g);return c.callbacks(f)}},getMasked:function(a,b){var g=[],d=void 0===b?c.val():b+"",n=0,h=e.length,q=0,l=d.length,k=1,r="push",p=-1,t=0,y=[],v,z;f.reverse?(r="unshift",k=-1,v=0,n=h-1,q=l-1,z=function(){return-1<n&&-1<q}):(v=h-1,z=function(){return n<h&&q<l});for(var A;z();){var x=e.charAt(n),w=d.charAt(q),u=m.translation[x];if(u)w.match(u.pattern)?(g[r](w),u.recursive&&(-1===p?p=n:n===v&&(n=p-k),v===p&&(n-=k)),n+=k):w===A?(t--,A=void 0):u.optional?(n+=k,q-=k):u.fallback?(g[r](u.fallback),n+=k,q-=k):c.invalid.push({p:q,v:w,e:u.pattern}),q+=k;else{if(!a)g[r](x);w===x?(y.push(q),q+=k):(A=x,y.push(q+t),t++);n+=k}}d=e.charAt(v);h!==l+1||m.translation[d]||g.push(d);g=g.join("");c.mapMaskdigitPositions(g,y,l);return g},mapMaskdigitPositions:function(a,b,e){a=f.reverse?a.length-e:0;c.maskDigitPosMap={};for(e=0;e<b.length;e++)c.maskDigitPosMap[b[e]+a]=1},callbacks:function(a){var h=c.val(),g=h!==d,m=[h,a,b,f],q=function(a,b,c){"function"===typeof f[a]&&b&&f[a].apply(this,c)};q("onChange",!0===g,m);q("onKeyPress",!0===g,m);q("onComplete",h.length===e.length,m);q("onInvalid",0<c.invalid.length,[h,a,b,c.invalid,f])}};b=a(b);var m=this,d=c.val(),h;e="function"===typeof e?e(c.val(),void 0,b,f):e;m.mask=e;m.options=f;m.remove=function(){var a=c.getCaret();c.destroyEvents();c.val(m.getCleanVal());c.setCaret(a);return b};m.getCleanVal=function(){return c.getMasked(!0)};m.getMaskedVal=function(a){return c.getMasked(!1,a)};m.init=function(d){d=d||!1;f=f||{};m.clearIfNotMatch=a.jMaskGlobals.clearIfNotMatch;m.byPassKeys=a.jMaskGlobals.byPassKeys;m.translation=a.extend({},a.jMaskGlobals.translation,f.translation);m=a.extend(!0,{},m,f);h=c.getRegexMask();if(d)c.events(),c.val(c.getMasked());else{f.placeholder&&b.attr("placeholder",f.placeholder);b.data("mask")&&b.attr("autocomplete","off");d=0;for(var l=!0;d<e.length;d++){var g=m.translation[e.charAt(d)];if(g&&g.recursive){l=!1;break}}l&&b.attr("maxlength",e.length);c.destroyEvents();c.events();d=c.getCaret();c.val(c.getMasked());c.setCaret(d)}};m.init(!b.is("input"))};a.maskWatchers={};var d=function(){var b=a(this),e={},f=b.attr("data-mask");b.attr("data-mask-reverse")&&(e.reverse=!0);b.attr("data-mask-clearifnotmatch")&&(e.clearIfNotMatch=!0);"true"===b.attr("data-mask-selectonfocus")&&(e.selectOnFocus=!0);if(p(b,f,e))return b.data("mask",new l(this,f,e))},p=function(b,e,f){f=f||{};var c=a(b).data("mask"),d=JSON.stringify;b=a(b).val()||a(b).text();try{return"function"===typeof e&&(e=e(b)),"object"!==typeof c||d(c.options)!==d(f)||c.mask!==e}catch(t){}},h=function(a){var b=document.createElement("div"),d;a="on"+a;d=a in b;d||(b.setAttribute(a,"return;"),d="function"===typeof b[a]);return d};a.fn.mask=function(b,d){d=d||{};var e=this.selector,c=a.jMaskGlobals,h=c.watchInterval,c=d.watchInputs||c.watchInputs,t=function(){if(p(this,b,d))return a(this).data("mask",new l(this,b,d))};a(this).each(t);e&&""!==e&&c&&(clearInterval(a.maskWatchers[e]),a.maskWatchers[e]=setInterval(function(){a(document).find(e).each(t)},h));return this};a.fn.masked=function(a){return this.data("mask").getMaskedVal(a)};a.fn.unmask=function(){clearInterval(a.maskWatchers[this.selector]);delete a.maskWatchers[this.selector];return this.each(function(){var b=a(this).data("mask");b&&b.remove().removeData("mask")})};a.fn.cleanVal=function(){return this.data("mask").getCleanVal()};a.applyDataMask=function(b){b=b||a.jMaskGlobals.maskElements;(b instanceof a?b:a(b)).filter(a.jMaskGlobals.dataMaskAttr).each(d)};h={maskElements:"input,td,span,div",dataMaskAttr:"*[data-mask]",dataMask:!0,watchInterval:300,watchInputs:!0,useInput:!/Chrome\/[2-4][0-9]|SamsungBrowser/.test(window.navigator.userAgent)&&h("input"),watchDataMask:!1,byPassKeys:[9,16,17,18,36,37,38,39,40,91],translation:{0:{pattern:/\d/},9:{pattern:/\d/,optional:!0},"#":{pattern:/\d/,recursive:!0},A:{pattern:/[a-zA-Z0-9]/},S:{pattern:/[a-zA-Z]/}}};a.jMaskGlobals=a.jMaskGlobals||{};h=a.jMaskGlobals=a.extend(!0,{},h,a.jMaskGlobals);h.dataMask&&a.applyDataMask();setInterval(function(){a.jMaskGlobals.watchDataMask&&a.applyDataMask()},h.watchInterval)},window.jQuery,window.Zepto);
